module.exports = __webpack_public_path__ + "prod/1.42.2/img/tongcheng-icon.adc5eaf1.png";